import React, { createContext, useContext } from 'react';

export type BrowserAuthProviderName =
  | 'auth0'
  | 'descope'
  | 'legacy-msal'
  | 'oidc';

export type BrowserAuthContextValue = {
  authProvider: BrowserAuthProviderName;
  login: () => Promise<void> | void;
  logout: () => Promise<void> | void;
  getAccessToken: () => Promise<string | undefined> | string | undefined;
};

type BrowserAuthProviderProps = React.PropsWithChildren<{
  value: BrowserAuthContextValue;
}>;

const BrowserAuthContext = createContext<BrowserAuthContextValue | undefined>(
  undefined
);

export const BrowserAuthProvider: React.FC<BrowserAuthProviderProps> = ({
  children,
  value,
}) => {
  return (
    <BrowserAuthContext.Provider value={value}>
      {children}
    </BrowserAuthContext.Provider>
  );
};

export const useBrowserAuth = (): BrowserAuthContextValue => {
  const context = useContext(BrowserAuthContext);

  if (context === undefined) {
    throw new Error('useBrowserAuth must be used within a BrowserAuthProvider');
  }

  return context;
};
